import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import UserList from './userList';
import ChatWindow from './chatWindow';
import { LocalStorageKey } from '../../shared/enums';
import webSocket from '../../webSocket';

const Chat = () => {
    const [ready, setReady] = useState(false);
    const [searchParams] = useSearchParams();
    const [currentUser] = useState(
        JSON.parse(localStorage.getItem(LocalStorageKey.USER_DATA))
    );
    const [selectedUser, setSelectedUser] = useState(null);
    const selectedUserId = searchParams.get('userId');

    useEffect(() => {
        const socketUrl = process.env.REACT_APP_API_URL.replaceAll('http', 'ws').replaceAll('https', 'wss');
        webSocket.connect(socketUrl).then((succeed) => {
            setReady(succeed);
        });

    }, []);

    if (!ready) {
        return <div>Loading...</div>;
    }

    return (
        <div style={{ display: 'flex' }}>
            <UserList
                currentUser={currentUser}
                onSelectUser={setSelectedUser}
                selectedUserId={selectedUser?.id}
                initialSelectedUserId={selectedUserId}
            />
            <ChatWindow currentUser={currentUser} chatWith={selectedUser} />
        </div>
    );
};

export default Chat;
